/**
 * @returns {String}
 */
export default function getCurrentUrl() {
    return window.location.href;
}
